(function($){
  // alert($(window).height());
  
  //    $(".header__nav-button").click(function() {
  //       $(this).toggleClass("active", 500),
  //        $(".mobile-menu").toggleClass("open", 500)
  //    }), $(".btn-next").click(function() {
  //       $(this).next(".menu-inner").addClass("active-slide", 500)
  //    }), $(".back").click(function() {
  //       $(".menu-inner").removeClass("active-slide", 500)
  //    })
  
  //    $('.close-menu').click(function() {
  //       $(".mobile-menu").removeClass("open", 500)
  
  
  
  
   
  // });
  
  //     if ($('predictive-search').attr('[open=true]') !== undefined) {
  //     $('.underlay').addClass('show')
     
  // }
  //  else{
  //      $('.underlay').removeClass('show')
  
  //  }
  
   var autoslide = $('.hero-banner').attr("data-loop");
    var tiimer = $('.hero-banner').attr("data-time");
    
    console.log(tiimer);
     console.log(autoslide);
    if(autoslide == 'true'){
    autoslide = true;
    }
    else {autoslide = false}
   
    $('.hero-banner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyload:true,
    autoplay:autoslide,
    autoplaySpeed:tiimer,
    arrows: false,
    infinite:true,
    dots: true,
  });
  
    $('.home-pro-img-slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite:true,
    dots: true,
  });
  
  
  
  // $('.result_slide').slick({
  //   dots: true,
  //   infinite: true,
  //   // speed: 0,
  //   slidesToShow: 1,
  //   prevArrow:"<button type='button' class='slick-prev '><img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/3/assets/angle-prev.svg' class='img-fluid'></button>",
  //   nextArrow:"<button type='button' class='slick-next '><img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/3/assets/angle-next.svg' class='img-fluid'></i></button>",
  //   slidesToScroll: 1,
  //   centerMode: true,
  //   centerPadding: '80px', /* 68*/
  //   accesibility: false,
  //             draggable: false,
  //             swipe: false,
  //             touchMove: false,
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         centerPadding: '40px',
  //       }
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         centerMode: false,
  //         arrows:true,
  //           prevArrow: '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/3/assets/prev-a.svg"></span>',
  //       nextArrow: '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/3/assets/next-a.svg"></span>'
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         arrows:true,
  //         centerPadding: '0',
  //         centerMode: false,
  //          prevArrow: '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/3/assets/prev-a.svg"></span>',
  //          nextArrow: '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/3/assets/next-a.svg"></span>'
  
          
  //       }
  //     }
  
  //   ]
  // });
  
  
  $('.result_slide').owlCarousel({
    stagePadding: 80,
      loop:true,
      margin:0,
    dots:true,
    nav:true,
    touchDrag  : false,
       mouseDrag  : false,
    items:1,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/angle-prev.svg?v=1708170107'>","<img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/angle-next.svg?v=1708170107'>"],
    responsive:{
      0:{
        items:1,
        dots:true,
         stagePadding: 0,
          nav:true,
        navText: ["<img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/prev-a.svg?v=1708170107'>","<img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/next-a.svg?v=1708170107'>"],
        margin:0
    },
      992:{
          items:1,
         dots:true,
         stagePadding: 0,
         navText: ["<img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/prev-a.svg?v=1708170107'>","<img src='https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/next-a.svg?v=1708170107'>"],
          nav:true,
          margin:0
      },
      992:{
        items:1
    },
      1200:{
          items:1
      },
      1400:{
          items:1
      }
  }
  })
  
  
  
  
  $('.slide-brand-content').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite:true,
    arrows: false,
    dots:false,
    fade: true,
    asNavFor: '.slide-brand-img',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          // adaptiveHeight: true,
        }
      }
  
    ]
  });
    
  $('.slide-brand-img').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slide-brand-content',
    arrows: false,
    infinite:true,
    dots: false,
    // prevArrow: '<span class="slick-prev"><img src={{"prev-a.svg" | asset_url}}></span>',
    //   nextArrow: '<span class="slick-next"><img src={{"next-a.svg" | asset_url }}></span>',
      prevArrow: '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/prev-a.svg?v=1708170107"></span>',
    nextArrow: '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/next-a.svg?v=1708170107"></span>',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots:true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
  
    ]
    
  });
  
    $('.slide-brand-img2').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    infinite:true,
    dots: false,
      prevArrow: '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/prev-a.svg?v=1708170107"></span>',
    nextArrow: '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/next-a.svg?v=1708170107"></span>',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots:true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
  
    ]
    
  });
  
    $('.pro-test-slide').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    infinite:false,
    dots: false,
           prevArrow: '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/prev-a.svg"></span>',
           nextArrow: '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0796/8253/5740/t/7/assets/next-a.svg"></span>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots:true,
          arrows: true,
           infinite:true,
          slidesToShow: 1,
          centerPadding: '40px',
          centerMode: true,
          slidesToScroll: 1,
        }
      }
    ]
  });
           
  
  $('.bg-img, .product_card_banner').each(function(){
    $(this).find('img:first').hide();
    var _Bg = 'url('+ $(this).find('img:first').attr('src') + ')';
    $(this).css("background-image", _Bg);
    $(this).find('img:first').hide();
  }); 
  
    
  
  $('.single-blog-img>a ').each(function(){
    $(this).find('img').hide();
    var _Bg = 'url('+ $(this).find('img').attr('src') + ')';
    $(this).css("background-image", _Bg);
    $(this).find('img').hide();
  }); 
    $('.hair-banner-content').each(function(){
  
      $(this).find('img').hide();
    var _Bg = 'url('+ $(this).find('img').attr('src') + ')';
    $(this).css("background-image", _Bg);
    $(this).find('img').hide();
   
  }); 
  
  
  $('.back-top a').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });
  
  
  $('.read-m').click(function() {
     $('.moretext').toggleClass('h-auto' , 150);
  //$(this).text('Read Less -')== true ? $(this).text('Read MORE +') : $(this).text('Read Less -');
     $(this).toggleClass("active");
  
     if ( $(this).hasClass( "active" ) ) {
      $(this).text( "READ Less -" );
      
    } else {
       
      $(this).text( "READ MORE +" );
       
    }
  });
  
    $('.mobile-tab-content>h6').click(function(){
      $(this).toggleClass('active')
      $(this).next('.toggle-menu-tab').toggle('fast')
    })
  
  
     $('.m-droplink').click(function(){
      $(this).toggleClass('active')
      $(this).next('.m-dropdown').toggle('fast')
    })
  
    
  
    $(window).on('scroll', function () {
   setTimeout(function(){
      var cur_pos = $(this).scrollTop();
    
   $('.faq_sidebar .faq-content').each(function() {
      var top = $(this).offset().top - 200,
           bottom = top + $(this).outerHeight();
      
      if (cur_pos >= top && cur_pos <= bottom) {
         $('.faq_aside li').find('a').removeClass('active');
       $('.faq_sidebar .faq-content').removeClass('active');
        
        $(this).addClass('active');
        $('.faq_aside ul').stop().animate({scrollLeft: "+=150"}, 200);
         $('.faq_aside li').find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
      }
     else if (cur_pos < top) {
       $('.faq_aside ul').stop().animate({scrollLeft: "-=150"}, 200);
     }
     
    
    });
  
   },100)
  });
  
  
  
   
       
     //  $(window).on('popstate', function() {
     //     location.reload(true);
     // });
  
  $(document).ready(function() {
 
    var first_h4, first_div;
  setTimeout(function(){
    var first_h4 = $('.moretext').find('h4:first-of-type').height();
  var first_div = $('.moretext').find('h4:first-of-type+div p:first-of-type').height();
    $('.moretext').css('maxHeight', first_h4+first_div+5+'px');
  },200);
    
    
   $('.faq_aside li').find('a').on('click', function (e) {
    var $el = $(this),
      id = $el.attr('href');
  
     
    $('html, body').animate({
      scrollTop: $(id).offset().top - 180,
    }, 50);
  e.preventDefault();
  });
    });




		$('.not-cli').on('click', function(e) {
				e.preventDefault(); // prevent hard jump, the default behavior

				var target = $(this).attr("href"); 

				$("#movement").animate({"height": open_height}, {duration: slideDuration }, {easing: linear});

				$('html, body').stop().animate({
                  easing: linear,
						scrollTop: $(target).offset().top - 100
				}, 600, function() {
						
				});

			
		});

  
  
  
    $('body').on('click', '.bottom-arrow', function() {
     $('.product__thumbs__holder').stop().animate({scrollTop: "+=120"}, 500);
     $('.top-arrow').removeClass('hidden');
      $(".product__wrapper--thumbnails-left .product__thumbs__holder").css({'padding-top':'30px'});
  });
  
  $('body').on('click', '.top-arrow', function() {
     $('.product__thumbs__holder').stop().animate({scrollTop: "-=120"}, 500);
  });
  
  function resizeColl(){
    $('.colection-row-t').each(function(){
  
          var _This = $(this);
          var first_h = _This.find('.product_card:first-of-type').height();
          var heading_h = _This.find('.single-pro-type').find('.heading').outerHeight();
          _This.find('.single-pro-type').find('.img').css('height', (first_h-heading_h)+'px');
          _This.find('.single-pro-type').find('.img').find('img').css({'height': '100%', 'width': 'auto', 'object-fit':'cover'})
        })
  }
    
    $(document).ready(function() {
  
      
      if($(window).width() > 767){
        
          resizeColl();
          // $('.single-pro-type').each(function(){
          //   var heading_h = $(this).find('.heading').outerHeight();
            
            
            
          // })
      }
    // Get the height of the element
    var height = $(".product__thumbs__holder").outerHeight();
  
    // If the height is less than 50px, add the class "short"
    if (height >= 634) {
       $('.bottom-arrow').removeClass('hidden'); 
         $('.product__thumbs__holder').css('height', '633px');
  
    }
       else{
         $('.bottom-arrow').addClass('hidden');
       $('.product__thumbs__holder').css('height', 'auto');
    
    }
  });
  if($(window).width() > 767){
    $(window).resize(function(){
       resizeColl();
    });
  }
  //   function checkSize(){
  //   if($(".product__thumbs__holder2").height() >= 633) {
  //     $('.bottom-arrow').removeClass('hidden');
      
  //   }
  //   else{
  //        $('.bottom-arrow').addClass('hidden');
  //   }
  // }
  //   $(document).ready(function(){
  //   checkSize();
  
   
  // });
  
  
    
  
    $(document).ready(function(){
      // $('.accordion > li > .faq_ans').hide();
        
      // $('.accordion > li').click(function() {
      //   if ($(this).hasClass("active")) {
      //   $(this).removeClass("active").find(".faq_ans").slideUp();
      //   } else {
      //   $(".accordion > li.active .faq_ans").slideUp();
      //   $(".accordion > li.active").removeClass("active");
      //   $(this).addClass("active").find(".faq_ans").slideDown();
      //   }
      //   return false;
      // });
      //   $(".accordion > li:first").addClass("active");
      // $('.accordion > li:first>.faq_ans').slideDown();
  
  
      $('.accordion-custom li>a.h3').click(function() {
        $(this).toggleClass('active');
       $(this).next(".faq_ans").toggle('fast');
        });
  
       $('.accordion-custom li>a.h3').eq(0).trigger('click');
      $('.accordion-custom li>a.h3.open').trigger('click');
      
       $('ul.accordion').accordion();
       // $('.pro-faq ul.accordion li a').eq(0).trigger('click');
  
      $(' ul.accordion li a').eq(0).trigger('click');
  
      if($('.accordion-custom > li:first-of-type > a').text()=='set Details') {
        // $('.accordion-custom li>a.h3').eq(1).trigger('click');
        $('.accordion-custom li>a.h3.open').trigger('click');
      }
     
  
      
     
      });
  
  $('.read').click(function() {
     $(this).next('.see-all-ingrad-wrap').toggle();
     $(this).toggleClass("active");
  
     if ( $(this).hasClass( "active" ) ) {
      $(this).text( "Hide All Ingredients -" );
      
    } else {
       
      $(this).text( "See All Ingredients +" );
       
    }
  });
  
    
  
  // $('.result_slide').on('afterChange', function(event, slick, currentSlide, nextSlide){
  //   $(".twentytwenty-container[data-orientation!='vertical']").twentytwenty({default_offset_pct: 0.5});
  
  // });
  // $(document).ready(function(){
  //     $(".twentytwenty-container[data-orientation!='vertical']").twentytwenty({default_offset_pct: 0.5});
  //   });
  
    function scaleToFill() {
        $('video.video-backgrounds').each(function(index, videoTag) {
           var $video = $(videoTag),
               videoRatio = videoTag.videoWidth / videoTag.videoHeight,
               tagRatio = $video.width() / $video.height(),
               val;
            
           if (videoRatio < tagRatio) {
               val = tagRatio / videoRatio * 1.02; // size increased by 2% because value is not fine enough and sometimes leaves a couple of white pixels at the edges
           } else if (tagRatio < videoRatio) {
               val = videoRatio / tagRatio * 1.02;
           }
           
           $video.css('transform','scale(' + val  + ',' + val + ')');
            $('video.video-backgrounds').show();
        });    
    }
    
    $(function () {
        scaleToFill();
        $('.video-backgrounds').on('loadeddata', scaleToFill);
        
        $(window).resize(function() {
            scaleToFill();
           
        });
    });
  
  
  
      $('.select-toggle').click(function(){
   // $(this).next('.dropdown-days').toggleClass('actives');
       $(this).next('.dropdown-days').toggle(1);
         $(this).next('.dropdown-days').toggleClass('ga14');
    $(this).toggleClass('active-menu');
   });
   $('.select-dropdown .dropdown-days label').on('click', function() {
    var getValue = $(this).text();
    $('.select-dropdown .dropdown-days>label').removeClass("actives");
    $(this).addClass("active");
   // $('.select-dropdown .dropdown-days').removeClass("actives");
     $('.select-dropdown .dropdown-days').slideUp(1);
     $('.select-toggle').removeClass("active-menu");
  });
  $(".select-dropdown .dropdown-days label ").click(function() {
    $(this).closest('.select-dropdown').find('.select-toggle k').text($(this).text());
    
  });
      
      $('body').click(function() {
     //$('.select-dropdown .dropdown-days').removeClass("actives");
        $('.select-dropdown .dropdown-days').slideUp(1);
         $('.select-toggle').removeClass("active-menu");
        
  });
  
  $('.select-toggle').click(function(event){
     event.stopPropagation();
  });
  
    if ($(window).width() > 992) {
     $('.sidear_blog .scrollbars').removeClass('scrollbar')
  }
  else {
   $('.sidear_blog .scrollbars').addClass('scrollbar')
  }
  
      if ($(window).width() > 769) {
     $('.product__thumbs__holder').removeClass('scrollbar')
  }
  else {
   $('.product__thumbs__holder').addClass('scrollbar')
  }
  
    
    
    
  // $('.faq_aside').scrollToFixed( {
  //             top: 0,
  //         });
  
  
              // $('.faq_aside').scrollToFixed({
              //     marginTop: $('.header-sections').outerHeight(true) + 10,
              // });
         
   
        $(window).on("load",function(){
  
          //       $(".scrollbar").mCustomScrollbar({
          //         axis:"x",
          //   autoExpandScrollbar:true,
          //          advanced:{autoScrollOnFocus:false, updateOnContentResize: true},
          //           scrollInertia:500,
                  
          // });
      //           $(".scrollbar").mCustomScrollbar({
      //             axis:"x",
          // 	autoExpandScrollbar:true,
      //              advanced:{autoScrollOnFocus:false, updateOnContentResize: true},
      //               scrollInertia:500,
                  
          // });
          
  
        });
  
  
            $('.mega-menu-tab li a').on('mouseenter', function(){
    var tag = $(this).attr('data-rel');
     $(this).parent().siblings().children().removeClass('active');
    $(this).addClass('active');
    $("#"+tag).fadeIn('slow').siblings(".menu-tab-box").hide();
          
  });
  
    
    
        $('.tab-menu li a').on('click', function(){
    var target = $(this).attr('data-rel');
     $(this).parent().siblings().children().removeClass('active');
    $(this).addClass('active');
    $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
  
    $('.pro-test-slide').slick('setPosition');
          // $('.result_slide').slick('setPosition');
          $(".result_slide.owl-carousel").trigger('refresh.owl.carousel');
  
          $('.mCSB_container').css('left', '0px');
      
          
  });
  
  
  
  //   if ($(".product__slide").hasClass("is-selected")) {
  //    let vid = $(this).find('video');
  //     vid.get(0).play();
    
  // }
  //   else{
  //        vid.get(0).pause();
  //   }
  
  
  $('.product__thumb__link').click(function(){
   let vid = $('.product__slides').find('video');
     if(vid) {
       vid.get(0).pause();
     }
  });
  
  
  
      var KlaviyoSubscribe = KlaviyoSubscribe || {};
  (function () {
      if (!KlaviyoSubscribe._loaded) {
          KlaviyoSubscribe._loaded = !0;
          var m = {
                  "modal.html":
                      '<div class="klaviyo_modal" style="display:none;"><div class="klaviyo_inner"><a href="#" class="klaviyo_close_modal klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_fieldset"></div><div class="klaviyo_fine_print"></div><div class="klaviyo_form_actions"><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="klaviyo_below_submit"></div><div class="error_message ahah" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>',
                  "flyout.html":
                      '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_flyout_action"><a href="#"><span /> &raquo;</a></div></div></div>',
                  "flyout_form.html":
                      '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_inline_fieldset"><input type="email" name="email" placeholder="Your email address" /><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="error_message gggg" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>',
              },
              n = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              p = { $email: "Email Address", $first_name: "First Name", $last_name: "Last Name" },
              h = "klaClosedPopup";
          KlaviyoSubscribe._debug = -1 < document.location.hash.indexOf("#test");
          KlaviyoSubscribe.has_called_bootstrap = !1;
          KlaviyoSubscribe.is_requirements_loaded = !1;
          KlaviyoSubscribe.bootstrap_queue = [];
          KlaviyoSubscribe.bootstrap_attempts = 0;
          KlaviyoSubscribe.instances = {};
          KlaviyoSubscribe.isDebugMode = function () {
              return KlaviyoSubscribe._debug;
          };
          KlaviyoSubscribe.bootstrap = function (a) {
              KlaviyoSubscribe.has_called_bootstrap || ((KlaviyoSubscribe.has_called_bootstrap = !0), KlaviyoSubscribe.loadCss("//a.klaviyo.com/media/css/public/klaviyo_subscribe.css"), KlaviyoSubscribe.fetchRequirements(a));
          };
          KlaviyoSubscribe.setHasClosedModalCookieName = function (a) {
              h = a || h;
          };
          KlaviyoSubscribe.loadScript = function (a, b, c) {
              var d = document.getElementsByTagName("head")[0],
                  e = document.createElement("script");
              e.type = "text/javascript";
              e.src = a;
              d.appendChild(e);
              KlaviyoSubscribe.log("Loaded JS", a);
              KlaviyoSubscribe.whenTrue(b, c);
          };
          KlaviyoSubscribe.loadCss = function (a) {
              var b = document.getElementsByTagName("head")[0],
                  c = document.createElement("link");
              c.rel = "stylesheet";
              c.type = "text/css";
              c.href = a;
              b.appendChild(c);
              KlaviyoSubscribe.log("Loaded CSS", a);
          };
          KlaviyoSubscribe.injectCSS = function (a) {
              var b = document.getElementsByTagName("head")[0],
                  c = document.createElement("style");
              c.type = "text/css";
              c.styleSheet ? (c.styleSheet.cssText = a) : c.appendChild(document.createTextNode(a));
              b.appendChild(c);
          };
          KlaviyoSubscribe.whenTrue = function (a, b) {
              var c = 0,
                  d = function () {
                      a() ? b() : (c++, 100 > c && setTimeout(d, 200));
                  };
              d();
          };
          KlaviyoSubscribe.loadJQuery = function (a) {
              KlaviyoSubscribe.loadScript(
                  "//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",
                  function () {
                      return !!window.jQuery;
                  },
                  a
              );
          };
          KlaviyoSubscribe.loadJQueryForm = function (a) {
              KlaviyoSubscribe.loadScript(
                  "//cdnjs.cloudflare.com/ajax/libs/jquery.form/3.32/jquery.form.min.js",
                  function () {
                      return !!window.jQuery && jQuery.fn.ajaxForm && jQuery.fn.formSerialize;
                  },
                  a
              );
          };
          KlaviyoSubscribe.fetchRequirements = function (a) {
              document.getElementsByTagName("head");
              a = a || {};
              if (window.jQuery) jQuery.fn.ajaxForm ? KlaviyoSubscribe.processQueue() : KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue);
              else {
                  var b = function () {
                      KlaviyoSubscribe.log("jQuery loaded.");
                      KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue);
                  };
                  !0 === a.assume_jquery
                      ? KlaviyoSubscribe.whenTrue(function () {
                            return !!window.jQuery;
                        }, b)
                      : KlaviyoSubscribe.loadJQuery(b);
              }
          };
          KlaviyoSubscribe.processQueue = function () {
              var a,
                  b = function () {
                      for (KlaviyoSubscribe.log("Processing queue."); (a = KlaviyoSubscribe.bootstrap_queue.shift()); ) a();
                      KlaviyoSubscribe.bootstrap_queue.push = function (a) {
                          a();
                      };
                  };
              KlaviyoSubscribe.log("Waiting for DOM to process queue.");
              jQuery(b);
              setTimeout(b, 5e3);
          };
          KlaviyoSubscribe.executeWhenRequirementsLoaded = function (a) {
              KlaviyoSubscribe.bootstrap_queue.push(a);
          };
          KlaviyoSubscribe.watchField = function (a, b, c) {
              c = c || {};
              c.type = c.type || "text";
              if ("email" === b || "$email" === b) c.type = "email";
              KlaviyoSubscribe.bootstrap();
              KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
                  KlaviyoSubscribe.log("Watching field", a, jQuery(a).length);
                  var d = function (a) {
                      a = jQuery.trim($(a.target).val());
                      KlaviyoSubscribe.log("Watch field value", a);
                      if ("email" !== c.type || n.test(a)) {
                          if (window._learnq && _learnq.push) {
                              var d = {};
                              d[b] = a;
                              _learnq.push(["identify", d]);
                          }
                          c.callback && c.callback(b, a);
                      }
                  };
                  if (c.delegate) jQuery(c.delegate).on("change blur", a, d);
                  else jQuery(a).on("change blur", d);
              });
          };
          KlaviyoSubscribe.watchFormSubmission = function (a, b) {
              b = b || {};
              b.properties = b.properties || {};
              b.list &&
                  (KlaviyoSubscribe.bootstrap(),
                  KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
                      if (b.properties) {
                          var c = [];
                          jQuery.each(b.properties, function (a, b) {
                              c.push(a);
                          });
                          c.length && (b.properties.$fields = c.join(","));
                      }
                      KlaviyoSubscribe.log("Watching form", a, jQuery(a).length);
                      var d = function (a) {
                          var c = $(a.target);
                          if (window._learnq && _learnq.identify) {
                              var d = _learnq.identify();
                              if (d && (d = d.$email || d.email)) {
                                  if (b.if) {
                                      var e = jQuery(b.if);
                                      if (!e.length || (e.is(":checkbox") ? !e.is(":checked") : !e.val())) {
                                          KlaviyoSubscribe.log("Subscribe if fails", e);
                                          return;
                                      }
                                  }
                                  d = jQuery.extend({ g: b.list, email: d }, b.properties);
                                  KlaviyoSubscribe.log("Subscribing", d);
                                  $.post("//manage.kmail-lists.com/ajax/subscriptions/subscribe", d);
                                  KlaviyoSubscribe._logMetric("submitModal", b.list);
                                  b.wait_seconds &&
                                      (a.preventDefault(),
                                      setTimeout(function () {
                                          KlaviyoSubscribe.log("Submitting form", c);
                                          c.get(0).submit();
                                      }, 1e3 * b.wait_seconds));
                              }
                          }
                      };
                      if (b.delegate) jQuery(b.delegate).on("submit", a, d);
                      else jQuery(a).on("submit", d);
                  }));
          };
          KlaviyoSubscribe.attachToForms = function (a, b) {
              b = b || {};
              var c = b.extra_properties || {};
              c.$source = c.$source || "$embed";
              KlaviyoSubscribe.bootstrap();
              KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
                  KlaviyoSubscribe.log("Attaching to forms", a, jQuery(a).length);
                  jQuery(a).each(function () {
                      var a = jQuery(this),
                          e = a.data("ajax-submit");
                      e || (e = "//manage.kmail-lists.com/ajax/subscriptions/subscribe");
                      a.ajaxForm({
                          url: e,
                          type: "POST",
                          beforeSubmit: function (b, d, e) {
                              try {
                                  if (!KlaviyoSubscribe.isFormValid(a)) return !1;
                              } catch (k) {
                                  return KlaviyoSubscribe.log(k), a.find(".error_message").show().html('<p>'+k+'</p>'), a.trigger("klaviyo.subscribe.error"), !1;
                              }
                              KlaviyoSubscribe.log("$source", c.$source);
                              KlaviyoSubscribe.normalizeFormFields(b, a, c, e);
                              KlaviyoSubscribe._logMetric(
                                  "submitModal",
                                  b.find(function (a) {
                                      return "g" === a.name;
                                  }).value
                              );
                              a.find(".klaviyo_submit_button").attr("disabled", !0);
                          },
                          success: function (c, d, e) {
                              a.find(".success_message, .error_message").hide();
                              a.find(".klaviyo_submit_button").attr("disabled", !1);
                              c.success
                                  ? (KlaviyoSubscribe.setClosedModalCookie(),
                                    (d = a.find(".success_message").show()),
                                    document.getElementById('mgg').style.display = "none",
                                     document.getElementById('mgg1').style.display = "none",
                                    d.length || (d = a.parent().find(".success_message").show()),
                                    window._learnq && _learnq.push && (e = a.find('[name="email"]').val()) && (_learnq.push(["identify", { $email: e }]), _learnq.push(["trackActivity"])),
                                    b.success_url
                                        ? (window.location = b.success_url)
                                        : (!0 !== b.custom_success_message &&
                                              d.html(b.success_message || '<h3>YOU\'RE IN</h3><div class="klaviyo_subheader"><p>Good things are coming your way.</p></div>').end(),
                                          !0 === b.hide_form_on_success && (a.find(".klaviyo_field_group input, .klaviyo_form_actions").hide(), a.is(".klaviyo_horizontal_form") && a.find(".klaviyo_field_group").hide()),
                                          b.success && b.success(a, c.data),
                                          a.trigger("klaviyo.subscribe.success").resetForm()))
                                  : (KlaviyoSubscribe.log(c.errors), a.find(".error_message").show().html(c.errors.join(" ")), a.trigger("klaviyo.subscribe.error"));
                          },
                      });
                      KlaviyoSubscribe.log("Attached to form", this);
                  });
              });
          };
          KlaviyoSubscribe.attachModalSignUp = function (a) {
              a = a || {};
              a.pages = a.pages || [];
              a.excluded_pages = a.excluded_pages || [];
              a.delay_seconds = a.delay_seconds || 0.1;
              a.delay_num_pages = a.delay_num_pages || 0;
              a.content = a.content || {};
              a.extra_properties = a.extra_properties || {};
              a.extra_properties.$source = a.extra_properties.$source || "$modal";
              a.list &&
                  (KlaviyoSubscribe.bootstrap(),
                  KlaviyoSubscribe.setHasClosedModalCookieName(a.has_closed_modal_cookie_name),
                  KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
                      var b = KlaviyoSubscribe._buildModalSignUp(a);
                      b.find('[name="g"]').val(a.list);
                      b.appendTo(jQuery("body"));
                      KlaviyoSubscribe.attachToModalForm(b, {
                          list: a.list,
                          pages: a.pages,
                          excluded_pages: a.excluded_pages,
                          delay: a.delay_seconds,
                          delay_num_pages: a.delay_num_pages,
                          ignore_cookie: a.ignore_cookie,
                          extra_properties: a.extra_properties,
                          custom_success_message: !!a.content.success,
                          success_url: a.success_url,
                          success: function (b) {
                              b.hide();
                              a.success && a.success(b);
                          },
                      });
                  }));
          };
          KlaviyoSubscribe._buildModalSignUp = function (a) {
              var b = a.content;
              b.fields = b.extra_fields || [];
              -1 === jQuery.inArray("$email", b.fields) && b.fields.unshift("$email");
              if (b.element) return jQuery(b.element);
              var c = jQuery(m["modal.html"])
                  .attr("id", "k_id_modal")
                  .find(".klaviyo_header")
                  .html(b.header || "Interested in our Newsletter?")
                  .end()
                  .find(".klaviyo_subscription_form")
                  .attr("action", a.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe")
                  .data("ajax-submit", a.ajax_subscribe_url || "//manage.kmail-lists.com/ajax/subscriptions/subscribe")
                  .end()
                  .find(".klaviyo_submit_button span")
                  .html(b.button || "Subscribe")
                  .end();
              b.clazz && c.addClass(b.clazz);
              b.styles && KlaviyoSubscribe.injectCSS(b.styles);
              !1 !== b.subheader && c.find(".klaviyo_subheader").html(b.subheader || "Stay in the know with news and promotions.");
              b.below_submit ? c.find(".klaviyo_below_submit").html(b.below_submit) : c.find(".klaviyo_below_submit").hide();
              b.success && c.find(".success_message").html(b.success);
              !0 === a.ack && c.append(jQuery('<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'));
              var d = c.find(".klaviyo_fieldset");
              jQuery.each(b.fields, function (a, b) {
                  "string" === typeof b && (b = { name: b });
                  b.type || (b.type = "$email" === b.name ? "email" : "text");
                  b.label || (b.label = p[b.name] || b.name);
                  a = "k_id_modal_" + b.name;
                  d.append(
                      jQuery('<div class="klaviyo_field_group" />')
                          .append(jQuery("<label />").attr("for", a).html(b.label))
                          .append(jQuery("<input />").attr({ type: b.type, id: a, name: "$" === b.name[0] ? b.name.slice(1) : b.name }))
                  );
              });
              a = b.fine_print || "";
              b.email_frequency && (a += " Our newsletter is delivered to your inbox " + b.email_frequency + ".");
              c.find(".klaviyo_fine_print").html(a);
              return c;
          };
          KlaviyoSubscribe.attachToModalForm = function (a, b) {
              b = b || {};
              b.pages = b.pages || [];
              b.excluded_pages = b.excluded_pages || [];
              b.extra_properties = b.extra_properties || {};
              b.extra_properties.$source = b.extra_properties.$source || "$modal";
              void 0 === b.delay_seconds && (b.delay_seconds = void 0 === b.delay ? 2 : b.delay);
              KlaviyoSubscribe.bootstrap();
              KlaviyoSubscribe.setHasClosedModalCookieName(b.has_closed_modal_cookie_name);
              KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
                  var c = jQuery(a);
                  KlaviyoSubscribe.attachToForms(jQuery(a).find(".klaviyo_subscription_form"), b);
                  c.delegate(".klaviyo_close_modal", "click", function (a) {
                      a.preventDefault();
                      c.hide();
                      KlaviyoSubscribe.setClosedModalCookie();
                      KlaviyoSubscribe._logMetric("closeModal", b.list);
                  });
                  c.click(function (a) {
                      a.currentTarget === a.target && (c.hide(), KlaviyoSubscribe.setClosedModalCookie());
                  });
                  KlaviyoSubscribe._canShowElem(b) &&
                      jQuery(function () {
                          setTimeout(function () {
                              KlaviyoSubscribe._logMetric("openModal", b.list);
                              c.fadeIn(1e3);
                              c.trigger("klaviyo.modal.show");
                          }, 1e3 * b.delay_seconds);
                      });
              });
          };
          KlaviyoSubscribe.attachFlyoutSignUp = function (a) {
              a = a || {};
              a.pages = a.pages || [];
              a.excluded_pages = a.excluded_pages || [];
              a.delay_scroll = void 0 === a.delay_scroll ? 50 : a.delay_scroll;
              a.delay_seconds = a.delay_seconds || 0.1;
              a.delay_num_pages = a.delay_num_pages || 0;
              a.position = a.position || "right";
              a.content = a.content || {};
              a.extra_properties = a.extra_properties || {};
              a.extra_properties.$source = a.extra_properties.$source || "$flyout";
              void 0 === a.modal_content && (a.modal_content = a.content);
              a.list &&
                  (KlaviyoSubscribe.bootstrap(),
                  KlaviyoSubscribe.setHasClosedModalCookieName(a.has_closed_modal_cookie_name),
                  KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
                      var b = !1 === a.modal_content,
                          c = KlaviyoSubscribe._buildFlyoutSignUp(jQuery.extend({ include_form: b }, a));
                      c.appendTo(jQuery("body"));
                      if (b) {
                          var d = a.success;
                          a.success = function (a) {
                              a.hide();
                              KlaviyoSubscribe.setClosedModalCookie();
                              d && d(a);
                          };
                          a.custom_success_message = !!a.content.success;
                          c.find('[name="g"]').val(a.list);
                          KlaviyoSubscribe.attachToForms(c.find(".klaviyo_subscription_form"), a);
                      }
                      KlaviyoSubscribe.attachToFlyout(c, {
                          list: a.list,
                          pages: a.pages,
                          excluded_pages: a.excluded_pages,
                          delay: a.delay_seconds,
                          delay_scroll: a.delay_scroll,
                          delay_num_pages: a.delay_num_pages,
                          position: a.position,
                          ignore_cookie: a.ignore_cookie,
                          extra_properties: a.extra_properties,
                          click: function (b) {
                              b = KlaviyoSubscribe._buildModalSignUp({ content: a.modal_content });
                              b.find('[name="g"]').val(a.list);
                              b.appendTo(jQuery("body"));
                              KlaviyoSubscribe.attachToModalForm(b, {
                                  list: a.list,
                                  delay: 0.01,
                                  extra_properties: a.extra_properties,
                                  success_url: a.success_url,
                                  success: function (b) {
                                      b.hide();
                                      a.success && a.success(b);
                                  },
                              });
                          },
                      });
                  }));
          };
          KlaviyoSubscribe._buildFlyoutSignUp = function (a) {
              var b = a.content;
              if (b.element) return jQuery(b.element);
              var c = jQuery(m[a.include_form ? "flyout_form.html" : "flyout.html"])
                  .attr("id", "k_id_flyout")
                  .find(".klaviyo_header")
                  .html(b.header || "Interested in our Newsletter?")
                  .end()
                  .find(".klaviyo_subscription_form")
                  .attr("action", a.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe")
                  .data("ajax-submit", a.ajax_subscribe_url || "//manage.kmail-lists.com/ajax/subscriptions/subscribe")
                  .end()
                  .find(".klaviyo_flyout_action a span, .klaviyo_submit_button span")
                  .html(b.button || "Subscribe")
                  .end();
              c.addClass("klaviyo_" + a.position);
              b.clazz && c.addClass(b.clazz);
              b.styles && KlaviyoSubscribe.injectCSS(b.styles);
              !1 !== b.subheader && c.find(".klaviyo_subheader").html(b.subheader || "Stay in the know with news and promotions.");
              b.success && c.find(".success_message").html(b.success);
              !0 === a.ack && c.find(".klaviyo_inner").append(jQuery('<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'));
              return c;
          };
          KlaviyoSubscribe.attachToFlyout = function (a, b) {
              b = b || {};
              b.pages = b.pages || [];
              b.excluded_pages = b.excluded_pages || [];
              b.position = b.position || "right";
              b.extra_properties = b.extra_properties || {};
              b.extra_properties.$source = b.extra_properties.$source || "$flyout";
              KlaviyoSubscribe.bootstrap();
              KlaviyoSubscribe.setHasClosedModalCookieName(b.has_closed_modal_cookie_name);
              KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
                  var c = jQuery(a);
                  c.delegate(".klaviyo_close_flyout", "click", function (a) {
                      a.preventDefault();
                      c.hide();
                      KlaviyoSubscribe.setClosedModalCookie();
                      KlaviyoSubscribe._logMetric("closeModal", b.list);
                  });
                  c.find(".klaviyo_flyout_action a").click(function (a) {
                      a.preventDefault();
                      c.hide();
                      b.click && b.click();
                  });
                  KlaviyoSubscribe._canShowElem(b) &&
                      jQuery(function () {
                          var a = b.delay_scroll,
                              e = function () {
                                  if (!c.data("opened")) {
                                      var a = b.delay_seconds || b.delay;
                                      void 0 === a && (a = 2);
                                      setTimeout(function () {
                                          if (!c.data("opened")) {
                                              c.data("opened", !0);
                                              c.trigger("klaviyo.flyout.show");
                                              var a = c.find(".klaviyo_inner"),
                                                  d = -1 < jQuery.inArray(b.position, ["left", "right", "bottom", "top"]) ? b.position : "right",
                                                  e = {},
                                                  g;
                                              e[d] = 0;
                                              c.css("visibility", "hidden").show();
                                              KlaviyoSubscribe._logMetric("openModal", b.list);
                                              "left" === d ? (g = 1.2 * -a.width()) : "right" === d ? (g = 1.2 * -a.width()) : "top" === d ? (g = 1.2 * -a.height()) : "bottom" === d && (g = 1.2 * -a.height());
                                              a.css(d, g);
                                              c.css("visibility", "visible");
                                              a.animate(e, 1e3 * (b.slide_seconds || 2));
                                          }
                                      }, 1e3 * a);
                                  }
                              };
                          if (!1 === a || 0 === a) e();
                          else {
                              var f = jQuery(document),
                                  q = jQuery(window),
                                  g = "bottom" === a ? 95 : a,
                                  k = function () {
                                      var a = f.height() - q.height();
                                      (0 > a ? 100 : (100 * f.scrollTop()) / a) > g && (e(), f.unbind("scroll", k));
                                  };
                              f.scroll(k);
                          }
                      });
              });
          };
          KlaviyoSubscribe.isFormValid = function (a) {
              var b = a.find('[name="email"]').val();
              if (!b || !/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(b)) throw (KlaviyoSubscribe.log("Invalid email address"), "Invalid email address");
              a.find('input[required="true"], select[required="true"]').each(function (b, d) {
                  d = jQuery(d);
                  if (d.is(":radio") || d.is(":checked")) {
                      has_value = !!a.find('[name="' + d.attr("name") + '"]:checked').length;
                      if (!has_value) throw (KlaviyoSubscribe.log("Required field missing", d.attr("name")), "Required field missing: " + d.attr("name"));
                      return has_value;
                  }
                  if (!d.val()) throw (KlaviyoSubscribe.log("Required field missing", d.attr("name")), "Required field missing: " + d.attr("name"));
              });
              a.find(".select-date-widget").each(function (a, b) {
                  b = jQuery(b);
                  a = KlaviyoSubscribe._int(b.find('[name$="_day"]').val());
                  var c = KlaviyoSubscribe._int(b.find('[name$="_month"]').val());
                  b = KlaviyoSubscribe._int(b.find('[name$="_year"]').val());
                  if (!(isNaN(a) || isNaN(c) || isNaN(b))) {
                      switch (c) {
                          case 1:
                          case 3:
                          case 5:
                          case 7:
                          case 8:
                          case 10:
                          case 12:
                              if (1 <= a && 31 >= a) return;
                          case 4:
                          case 6:
                          case 9:
                          case 11:
                              if (1 <= a && 30 >= a) return;
                          case 2:
                              if (1 <= a && a <= (b % 4 ? 28 : 29)) return;
                      }
                      KlaviyoSubscribe.log("Invalid date", b, c, a);
                      throw "Invalid date";
                  }
              });
              return !0;
          };
          KlaviyoSubscribe.normalizeFormFields = function (a, b, c, d) {
              a.push({ name: "$timezone_offset", type: "text", value: this._getUtcOffset() });
              var e = [],
                  f;
              jQuery.each(c, function (b, c) {
                  a.push({ name: b, type: "text", value: c });
                  e.push(b);
              });
              e.length &&
                  (jQuery.each(a, function (a, b) {
                      if ("$fields" === b.name) return (f = b), !1;
                  }),
                  f ? (f.value += "," + e.join()) : a.push({ name: "$fields", type: "text", value: e.join() }));
              b.find(".select-date-widget").each(function (b, c) {
                  c = jQuery(c);
                  var d = c.find('[name$="_day"]');
                  b = c.find('[name$="_month"]');
                  var e = c.find('[name$="_year"]');
                  c = d.attr("name");
                  var f = b.attr("name"),
                      g = e.attr("name");
                  d = KlaviyoSubscribe._int(d.val());
                  var h = KlaviyoSubscribe._int(b.val());
                  e = KlaviyoSubscribe._int(e.val());
                  if (!(isNaN(d) || isNaN(h) || isNaN(e))) {
                      for (b = 0; b < a.length; ) {
                          var l = a[b];
                          !l || (l.name !== c && l.name !== f && l.name !== g) ? b++ : a.splice(b, 1);
                      }
                      a.push({ name: c.replace("_day", ""), required: !0, type: "text", value: KlaviyoSubscribe._formatDate(e, h, d) });
                  }
              });
          };
          KlaviyoSubscribe.isCurrentLocationInPatterns = function (a) {
              for (var b = location.toString(), c = 0, d = a.length; c < d; c++) if (KlaviyoSubscribe.patternMatchesUrl(a[c], b)) return !0;
              return !1;
          };
          KlaviyoSubscribe.patternMatchesUrl = function (a, b) {
              b = b.toLowerCase();
              if (a === b) return !0;
              if (-1 === a.indexOf("?")) {
                  var c = b.indexOf("?");
                  -1 !== c && (b = b.substring(0, c));
              }
              if (-1 === a.indexOf("*")) return (a = a.replace(/\/$/, "")), "" === a && (a = "/"), (b = b.replace(/\/$/, "")), a === b ? !0 : 0 === a.indexOf("/") ? ((b = KlaviyoSubscribe.parseDomain(b)), "" === a ? "/" === b : b === a) : !1;
              if (a === b) return !0;
              if (!a.length) return !1;
              c = a.replace(/[.+?|()\[\]{}\\]/g, "\\$&").replace(/\*/g, "(.*?)");
              c = /\/$/.test(c) ? "^" + c + "$" : "^" + c + "/?$";
              c = new RegExp(c, "i");
              return c.test(b) ? !0 : a.indexOf("/") ? !1 : c.test(KlaviyoSubscribe.parseDomain(b));
          };
          KlaviyoSubscribe.parseDomain = function (a) {
              return "/" + a.split("//")[1].split("/").splice(1).join("/");
          };
          KlaviyoSubscribe.incrPageViews = function () {
              var a = parseInt(KlaviyoSubscribe._getCookie("klaPages"), 10);
              isNaN(a) && (a = 0);
              a += 1;
              KlaviyoSubscribe._setCookie("klaPages", a, 31536e6);
              return a;
          };
          KlaviyoSubscribe.setClosedModalCookie = function () {
              KlaviyoSubscribe._setCookie(h, "1", 31536e6);
          };
          KlaviyoSubscribe.resetClosedModalCookie = function () {
              KlaviyoSubscribe._deleteCookie(h);
          };
          KlaviyoSubscribe.hasClosedModal = function () {
              return !!KlaviyoSubscribe._getCookie(h) && !KlaviyoSubscribe.isDebugMode();
          };
          KlaviyoSubscribe._setCookie = function (a, b, c) {
              c = new Date(new Date().getTime() + c);
              document.cookie = a + "=" + b + ";expires=" + c.toGMTString() + ";path=/";
          };
          KlaviyoSubscribe._getCookie = function (a) {
              return (a = new RegExp("(^|;)[ ]*" + a + "=([^;]*)").exec(document.cookie)) ? a[2] : "";
          };
          KlaviyoSubscribe._deleteCookie = function (a) {
              KlaviyoSubscribe._getCookie(a) && KlaviyoSubscribe._setCookie(a, "", -1);
          };
          KlaviyoSubscribe._getUtcOffset = function () {
              return new Date().getTimezoneOffset() / -60;
          };
          KlaviyoSubscribe._canShowElem = function (a) {
              return (a.delay_num_pages && a.delay_num_pages > KlaviyoSubscribe.incrPageViews()) ||
                  (a.pages.length && !KlaviyoSubscribe.isCurrentLocationInPatterns(a.pages)) ||
                  (a.excluded_pages.length && KlaviyoSubscribe.isCurrentLocationInPatterns(a.excluded_pages))
                  ? !1
                  : a.ignore_cookie || !KlaviyoSubscribe.hasClosedModal();
          };
          KlaviyoSubscribe._int = function (a) {
              return parseInt(a, 10);
          };
          KlaviyoSubscribe._formatDate = function (a, b, c) {
              1 === c.toString().length && (c = "0" + c);
              1 === b.toString().length && (b = "0" + b);
              return a + "-" + b + "-" + c;
          };
          KlaviyoSubscribe.log = function () {
              window.console && console.log && console.log(arguments);
          };
          KlaviyoSubscribe._logMetric = function (a, b) {};
          Array.prototype.find ||
              Object.defineProperty(Array.prototype, "find", {
                  value: function (a, b) {
                      if (null == this) throw new TypeError('"this" is null or not defined');
                      var c = Object(this),
                          d = c.length >>> 0;
                      if ("function" !== typeof a) throw new TypeError("predicate must be a function");
                      for (var e = 0; e < d; ) {
                          var f = c[e];
                          if (a.call(b, f, e, c)) return f;
                          e++;
                      }
                  },
              });
      }
  })();
  KlaviyoSubscribe.attachToForms("#email_signup", {
      hide_form_on_success: true,
    //success_message: "Thank you for signing up! Your special offer is on its way!"
    success_message:  "<h3>YOU\'RE IN</h3><div class='klaviyo_subheader'><p>Good things are coming your way.</p></div>"
  });
  KlaviyoSubscribe.attachToForms("#email_signupp", {
      hide_form_on_success: true,
    success_message: "Thanks for signing up!"
  });
   
              
  
  })(jQuery);
  
  $(document).ready(function() {
    if (window.location.href.indexOf("viewcart") > -1) {
      $("body").addClass("g-cart-open");
    }
  });
  
   $("#notifypop").on("click", ".notpopupbutton", function(e) { 
    var em = $(".notemail").val();
     var ifAnEmail = false;
    var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
    var ifAnEmail = testEmail.test(em);
    var vari = $(".notvariant").val();
     if( !em ) {
        $('.rea').show();
        $('.rea1').hide();
      }
      else if (!ifAnEmail && em){
        $('.rea1').show();
        $('.rea').hide();
      }
      else{
        $('.rea').hide();
        $('.rea1').hide();
        
  const optionsOne = {
    method: 'POST',
    headers: {revision: '2023-12-15', 'content-type': 'application/json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Back in stock subscription',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                  email: em,
                 properties: {productName: vari}
              }
            }
          }
        },
        relationships: {
          
          list: {
            data: {type: 'list', id: 'TPLdZa'}
          }
        }
      }
    })
  };
  
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=HD9p84', optionsOne)
    .then(response => console.log(response))
    .catch(err => console.error(err));
        
    const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      revision: '2023-12-15',
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: em 
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + vari
            }
          }
        }
      }
    })
  };
  
  fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=HD9p84', options)
     .then(response => console.log(response))
    .catch(err => console.error(err));
           $('.hideit').hide();
        $('.showit').show();
        
      }
   
     
   });


  jQuery('.video-background.sound').parent().click(function () {
	if ($(this).children(".video-background.sound").get(0).paused) {
		$(this).children(".video-background.sound").get(0).play(); $(this).children(".playpause").fadeOut();
	} else {
		$(this).children(".video-background.sound").get(0).pause();
		$(this).children(".playpause").fadeIn();
	}
});


  
  